<template>
  <v-window-item value="monthly-target">
    <v-card-text class="px-0">
      <v-table density="compact">
        <thead>
          <tr>
            <th>Month</th>
            <th class="text-right">Target Amount</th>
            <th class="text-right">Target Quantity</th>
            <th class="text-right">Achievement</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in monthlyTargetData" :key="item.month">
            <td>{{ item.month }}</td>
            <td class="text-right">{{ item.targetAmount }}</td>
            <td class="text-right">{{ item.targetQuantity }}</td>
            <td class="text-right">
              <v-chip
                  variant="tonal"
                  size="small"
                  :color="setItemColor(item)"
              >{{ item.achievement }}</v-chip>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card-text>
  </v-window-item>
</template>

<script>
export default {
  props: {
    monthlyTargetData: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    setItemColor(item) {
      if(Number(item.achievement) === 0){
        return 'red'
      } else if (Number(item.achievement) > 0 && Number(item.achievement) < Number(item.targetAmount)) {
        return 'yellow-darken-3'
      } else if (Number(item.achievement) === Number(item.targetAmount) && Number(item.achievement) > 0) {
        return 'green'
      } else if (Number(item.achievement) > Number(item.targetAmount) ) {
        return 'blue'
      }
    }
  }
};
</script>
